module.exports = __webpack_public_path__ + "img/apple.972780b0.svg";